// PURE DATA + loader arrows. No lazy(), no side effects (see ../types.ts contract).
// Events come from WordPress (the content-model engine's `event` preset) — no server
// routes and no database; the pages show an empty state when WordPress has none.
import type { ModuleManifest } from '../types';

export const eventsModule: ModuleManifest = {
  id: 'events',
  routes: [
    { path: '/events', load: () => import('./pages/EventsPage') },
    { path: '/events/:slug', load: () => import('./pages/EventDetailPage') },
  ],
  menuItems: [{ title: 'Events', path: '/events' }],
};
